var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_67_1653",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00049 2H21.5001V21.5007H2.00049V2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_67_1653)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.77349 11.5988C8.79149 11.6148 8.80849 11.6298 8.82549 11.6478C9.90449 12.7538 10.4995 14.2188 10.4995 15.7738V19.7578L12.7355 18.5398C12.9115 18.4438 13.0205 18.2558 13.0205 18.0488V15.7618C13.0205 14.2128 13.6095 12.7528 14.6785 11.6528L19.5155 6.50776C19.8285 6.17476 20.0005 5.73776 20.0005 5.27676V4.34076C20.0005 3.87676 19.6345 3.49976 19.1865 3.49976H4.31549C3.86649 3.49976 3.50049 3.87676 3.50049 4.34076V5.27676C3.50049 5.73776 3.67249 6.17476 3.98549 6.50676L8.77349 11.5988ZM10.1465 21.5008C9.94449 21.5008 9.74449 21.4468 9.56249 21.3388C9.21049 21.1288 8.99949 20.7578 8.99949 20.3458V15.7738C8.99949 14.6388 8.57649 13.5698 7.80549 12.7508C7.78249 12.7318 7.75949 12.7108 7.73949 12.6888L2.89349 7.53576C2.31749 6.92376 2.00049 6.12076 2.00049 5.27676V4.34076C2.00049 3.04976 3.03949 1.99976 4.31549 1.99976H19.1865C20.4615 1.99976 21.5005 3.04976 21.5005 4.34076V5.27676C21.5005 6.11976 21.1835 6.92176 20.6095 7.53476L15.7625 12.6888C14.9595 13.5168 14.5205 14.6058 14.5205 15.7618V18.0488C14.5205 18.8048 14.1115 19.4968 13.4535 19.8568L10.6925 21.3608C10.5205 21.4538 10.3335 21.5008 10.1465 21.5008Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter3);
export default __webpack_public_path__ + "static/media/Filter3.405645563dfa5eb99593f28506ab5d81.svg";
export { ForwardRef as ReactComponent };